import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import CupomForm from './components/CupomForm';

const Cupom = (props) => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Cupom</h3>
          <h3 className="page-subhead subhead">
            Adicione um novo cupom ou altere suas configurações
          </h3>
        </Col>
      </Row>
      <Row>
        <CupomForm isHorizontal={false} isAboveError props={props} />
      </Row>
    </Container>
  );
};

export default Cupom;
